export const createPythonBlob = (pythonCode: string) => {
  return new Blob([pythonCode], { type: 'text/x-python' });
};
